import _ from '../../../utils/underscore';
import GamePostMessageHandlerBase from './game_post_message_handler_base';
import GameCommonPostMessageActions from './game_common_post_message_actions';


export default class GameCommonPostMessageHandler extends GamePostMessageHandlerBase {
    static CLASS = 'GameCommonPostMessageHandler';
    init(params) {
        super.init(params);

        if(!params.serviceFactory) {
            this.throwArgumentExpected('12', 'init', 'serviceFactory', params);
        }

        if(_.isNullOrUndefined(params.isReal)) {
            this.throwArgumentExpected('16', 'init', 'isReal', params);
        }

        this._serviceFactory = params.serviceFactory;
        this._isReal = params.isReal;
    }

    executeAction(gameOptions, actionName, params) {

        if(!gameOptions) {
            this.throwArgumentExpected('26', 'executeAction', 'gameOptions');
        }

        if(!actionName) {
            this.logger.warn('action name parameter was not provided');
            return;
        }

        let actions = this._createPostMessageActions(gameOptions);

        let actionMethod = actions[actionName];

        if(_.isNullOrUndefined(actionMethod)) {
            this.logger.error(`${this.getClassName()} doesn't have a method named ${actionName}`);
            return;
        }

        if(_.isNullOrUndefined(params)) {
            actionMethod.call(actions);
        } else {
            actionMethod.call(actions, params);
        }
    }

    _createPostMessageActions(gameOptions) {
        return GameCommonPostMessageActions.create({
			serviceFactory: this._serviceFactory,
			isReal: this._isReal,
			gameOptions: gameOptions
		});
    }
}